import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'components/ui/Modal'
import { UIButton } from 'components/ui/Button'
import { Switch } from 'components/ui/Switch'
import { useModal } from 'providers/ModalProvider'
import { consentActions, consentSelectors } from 'store/consent'

export const CookiePreferencesModal = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { close } = useModal()
  const current = useSelector(consentSelectors.analytics)
  const [analytics, setAnalytics] = useState<boolean>(current === true)

  const save = () => {
    dispatch(consentActions.setAnalyticsConsent(analytics))
    close()
  }

  return (
    <Modal onClose={close}>
      <ModalHeader title={t('cookiePreferences.title')} icon="cookie-bite" />
      <ModalBody>
        <p className="tw-mb-4 tw-mt-0 tw-text-sm" style={{ color: 'var(--text-secondary)' }}>
          {t('cookiePreferences.intro')}
        </p>

        <div className="tw-flex tw-items-start tw-justify-between tw-gap-4 tw-py-3">
          <div>
            <p className="tw-m-0 tw-text-sm tw-font-semibold" style={{ color: 'var(--text-primary)' }}>
              {t('cookiePreferences.necessaryTitle')}
            </p>
            <p className="tw-m-0 tw-mt-1 tw-text-xs" style={{ color: 'var(--text-tertiary)' }}>
              {t('cookiePreferences.necessaryDesc')}
            </p>
          </div>
          <span className="tw-shrink-0 tw-text-xs tw-font-medium" style={{ color: 'var(--text-tertiary)' }}>
            {t('cookiePreferences.always')}
          </span>
        </div>

        <div className="tw-h-px tw-w-full" style={{ background: 'var(--page-border)' }} />

        <div className="tw-flex tw-items-start tw-justify-between tw-gap-4 tw-py-3">
          <div>
            <p className="tw-m-0 tw-text-sm tw-font-semibold" style={{ color: 'var(--text-primary)' }}>
              {t('cookiePreferences.analyticsTitle')}
            </p>
            <p className="tw-m-0 tw-mt-1 tw-text-xs" style={{ color: 'var(--text-tertiary)' }}>
              {t('cookiePreferences.analyticsDesc')}
            </p>
          </div>
          <Switch checked={analytics} onChange={setAnalytics} label={t('cookiePreferences.analyticsTitle')} />
        </div>
      </ModalBody>
      <ModalFooter>
        <UIButton onClick={save} className="tw-w-full">
          {t('cookiePreferences.save')}
        </UIButton>
      </ModalFooter>
    </Modal>
  )
}
